import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import apiService from '@/services/apiService/dashboards';
import get from 'lodash/get';
import inputRules from '@/mixins/input-rules';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
export default {
  name: 'WidgetChartDataOptionsEditor',
  mixins: [inputRules],
  props: {
    value: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      availableStates: [],
      isFetchingAvailableStates: true
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    editedWidget: {
      get() {
        const defaultAggregation = {
          enabled: true,
          duration: '1w',
          function: 'avg'
        };
        const aggregation = cloneDeep(get(this.value, 'aggregation', defaultAggregation));
        const defaultChartOptions = {
          stateIdentifiers: []
        };
        const chartOptions = cloneDeep(get(this.value, 'chartOptions', defaultChartOptions));
        return {
          ...this.value,
          aggregation,
          chartOptions
        };
      },
      set() {
        throw new Error('use specific setters');
      }
    },
    aggregationEnabled: {
      get() {
        return this.editedWidget.aggregation.enabled;
      },
      set(value) {
        this.setByKey('aggregation.enabled', value);
      }
    },
    aggregationDuration: {
      get() {
        return this.editedWidget.aggregation.duration;
      },
      set(value) {
        this.setByKey('aggregation.duration', value);
      }
    },
    aggregationFunction: {
      get() {
        return this.editedWidget.aggregation.function;
      },
      set(value) {
        this.setByKey('aggregation.function', value);
      }
    },
    stateIdentifiers: {
      get() {
        return this.editedWidget.chartOptions.stateIdentifiers;
      },
      set(value) {
        this.setByKey('chartOptions.stateIdentifiers', value);
      }
    },
    timeFilterAggregateDurationsItems() {
      const durations = ['5m', '15m', '1h', '6h', '1d', '1w', '1mo'];
      return durations.map(duration => ({
        text: this.$t(`Dashboards.components.widgetChartDataOptionsEditor.inputs.aggregate.duration.items.${duration}`),
        value: duration
      }));
    },
    timeFilterAggregateFunctionsItems() {
      const functions = ['avg', 'min', 'max', 'sum', 'median', 'count', 'latest'];
      return functions.map(functionName => ({
        text: this.$t(`Dashboards.components.widgetChartDataOptionsEditor.inputs.aggregate.function.items.${functionName}`),
        value: functionName
      }));
    },
    entityFilters() {
      return {
        twinFilter: get(this.value, 'twinFilter', {}),
        virtualDeviceFilter: get(this.value, 'virtualDeviceFilter', {})
      };
    }
  },
  watch: {
    entityFilters: {
      async handler() {
        this.fetchAvailableStates();
      },
      immediate: true,
      deep: true
    },
    'value.aggregation': {
      async handler() {
        if (!this.value.aggregation) {
          this.setByKey('aggregation', {
            enabled: true,
            duration: '1w',
            function: 'avg'
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    fetchAvailableStates: debounce(function () {
      this.actuallyFetchAvailableStates();
    }, 500),
    async actuallyFetchAvailableStates() {
      try {
        this.isFetchingAvailableStates = true;
        this.availableStates = await apiService.fetchAvailableStatesForDashboardFilter(this.dashboardId, this.entityFilters.twinFilter, this.entityFilters.virtualDeviceFilter, this.customParameters);
      } catch (e) {
        this.$snack(this.$t('Dashboards.components.widgetChartDataOptionsEditor.snack.error.couldNotFetchAvailableStates', {
          error: e
        }), 'error');
        console.error(e);
      } finally {
        this.isFetchingAvailableStates = false;
      }
    },
    setByKey(key, value) {
      const clone = cloneDeep(this.editedWidget);
      set(clone, key, value);
      this.$emit('input', clone);
    }
  }
};